import React, { useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import ConversationsModal from '../../elements/Modal/ConversationsModal';
import {
  PendingConversationsContainer,
  ChatPending
} from '../../elements/Modal/elements';
import { CONVERSATIONS } from './queries';
import Flash from 'app/src/elements/Modal/Flash';
import Conversations from './';
import {Text} from 'react-native';

import MessageInputContext from '../../contexts/MessageInputContext';

const getChatCountLabel = conversations => {
  return `${conversations.length} Chat${
    conversations?.length === 1 ? '' : 's'
  } awaiting response`
}

const PendingConversations = ({showConversations, setShowConversations,
  pendingConversations, openConversations
}) => {
  const { data, refetch } = useQuery(CONVERSATIONS, {variables: { scopes: ['pending'] }});
  const {
    pendingResponseIds,
    getConversationBuyerName
  } = useContext(MessageInputContext);

  if(!data) return null;
  const conversations = data?.conversations.filter(conversation =>
    conversation.isPendingResponse
  );

  // if(conversations?.length > 0) {
    return (
      showConversations ?
        <PendingConversationsContainer
          id='conversations-box'
          showConversations={showConversations}
          pendingConversations={pendingConversations}
          openConversations={openConversations}
        >
          <ConversationsModal
            showModal={showConversations}
            setShowModal={setShowConversations}
            modalType={getChatCountLabel(conversations)}
            pendingResponse={conversations?.length}
          >
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <div>
                <Conversations
                  setShowModal={setShowConversations}
                  pendingResponses={conversations?.length > 0}
                  indexRefetch={refetch}
                />
              </div>
            </div>
          </ConversationsModal>
        </PendingConversationsContainer> :

        <ChatPending
          onClick={() => setShowConversations(!showConversations)}
          pendingResponse={conversations?.length}
        >
          {pendingConversations?.length ?
            <Flash
              message={getChatCountLabel(conversations)}
              pendingResponse={conversations?.length}
            /> :
            <Text
              style={{
                fontSize: '20px',
                color: '#ffffff',
                fontWeight: 'bold'
              }}
            >
              {getChatCountLabel(conversations)}
            </Text>
          }
        </ChatPending>
    )
  // }
};

export default PendingConversations;